import React from 'react'
import { Routes, Route } from 'react-router-dom'
import GeneralFilter from './GeneralFilter'
import CreateEditGenFilter from './GeneralFilter/CreateEditGenFilter'
import AmountFilter from './AmountFilter'
import GeographicalFilter from './GeographicalFilter'
import CreateEditGeoFilter from './GeographicalFilter/CreateEditGeoFilter'
import CreateEditAmFilter from './AmountFilter/CreateEditAmFilter'
import RadiusFilter from './RadiusFilter'
import CreateEditRadFilter from './RadiusFilter/CreateEditRadFilter'

const Router: React.FC = () => {
  return <Routes>
    {/* General */}
    <Route path={'/'} element={<GeneralFilter />} />
    <Route path={'/general'} element={<GeneralFilter />} />
    <Route path={'/general/create'} element={<CreateEditGenFilter />} />
    <Route path={'/general/:id/edit'} element={<CreateEditGenFilter />} />

    {/* Amount */}
    <Route path={'/amount'} element={<AmountFilter />} />
    <Route path={'/amount/create'} element={<CreateEditAmFilter />} />
    <Route path={'/amount/:id/edit'} element={<CreateEditAmFilter />} />

    {/* Geographical */}
    <Route path={'/geographical'} element={<GeographicalFilter />} />
    <Route path={'/geographical/create'} element={<CreateEditGeoFilter />} />
    <Route path={'/geographical/:id/edit'} element={<CreateEditGeoFilter />} />

    {/* Radius */}
    <Route path={'/radius'} element={<RadiusFilter />} />
    <Route path={'/radius/create'} element={<CreateEditRadFilter />} />
    <Route path={'/radius/:id/edit'} element={<CreateEditRadFilter />} />

  </Routes>
}
export default Router